import React, { useState, useEffect, useRef, useCallback } from 'react';

import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';

import { sendAuthenticatedAsyncRequest } from 'services/AsyncRequestService';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { Formik } from 'formik';
import * as Yup from 'yup';
import DismissableModal from 'components/DismissableModal';
import { FaArrowRight } from "react-icons/fa";
import { FormSelect } from 'react-bootstrap';
import { showNotification } from 'services/NotificationService';

function Feedback(props) {
  const { children } = props;
  return (
    <Row className="m-1" style={{ color:"red", fontSize: 'x-small'}}>
    <Col md={1} className="pt-1">

        <FaArrowRight />
    </Col>
    <Col>{children}</Col>
  </Row>

  );
}


const CheckCustomerConfigurationOnSendGrid = () => {

  const [customers, setCustomers] = useState(null);
  const [requestInProgress, setRequestInProgress] = useState(false);
  const [loadingCustomers, setLoadingCustomers] = useState(false);
  const [isNotSetupCorrectly, setIsNotSetupCorrectly] = useState(false);
  const [errorMsgList, setErrorMsgList] = useState([]);
  const modalRef = useRef(null);

  const fetchCustomers = useCallback(() => {
    setLoadingCustomers(true);
    setIsNotSetupCorrectly(false);
    sendAuthenticatedAsyncRequest(
      `/customers/list`,
      "GET",
      null,
      (r) => { setCustomers(r.data); setLoadingCustomers(false); setIsNotSetupCorrectly(false); },
      (r) => { setCustomers(null); setLoadingCustomers(false); setIsNotSetupCorrectly(false); }
    );
  }, []);

  useEffect(() => {
    fetchCustomers();
  }, [fetchCustomers]);

  const checkSettingsOnSendGrid = (values, setSubmitting) => {
    sendAuthenticatedAsyncRequest(
      `/sendgrid-member-sync/check-configuration/customer/${values.selectedCustomer}`,
      "PUT",
      null,
      (r) => {
        setRequestInProgress(false);
        setIsNotSetupCorrectly(false);
        setSubmitting(false);
        showNotification({
          title: 'Action successful!',
          message: 'Customer is setup correctly on sendgrid',
          position: 'tc',
          type: "success"
        });
        if(modalRef.current) modalRef.current.handleClose();
      },
      (r) => {
        console.log(r.data)
        setRequestInProgress(false);
        setIsNotSetupCorrectly(true);
        setErrorMsgList(r.data.additionalErrorInfo);
        setSubmitting(false);
        showNotification({
          title: 'Error!',
          message: "Sendgrid not setup correctly for the selected customer",
          position: 'tc',
          type: "error"
        });
      }
    );
  }

  const formattedCustomers = customers ? customers.map(c => ({
    value: c.name, key: c.id
  })) : [];

  const checkSettingsFormSchema = Yup.object().shape({
    selectedCustomer: Yup.string().required('please select a customer')
  });

  return (
    <Card style={{ textAlign: 'center' }}>
      <Card.Body>
        <Card.Text>
          Check Customer Configuration on SendGrid.
        </Card.Text>
        <DismissableModal
          ref={modalRef}
          openModalButtonText="Check Config"
          openModalButtonStyle="info"
          openModalButtonBlock={true}
          openModalButtonDisabled={false}
          openModalButtonId='check-cust-config-btn-popup'
          preventCloseWhenClickedOutsideModal={true}
          onClose={() => { setErrorMsgList([]); setIsNotSetupCorrectly(false); }}
          hideFooter={true}
          title="SendGrid Configuration Check" >
          <Formik
            initialValues={{ selectedCustomer: '' }}
            onSubmit={(values, { setSubmitting }) => {
              checkSettingsOnSendGrid(values, setSubmitting)
            }}
            validationSchema={checkSettingsFormSchema}
            
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue

            }) => (
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col md={{ offset: '1', span: '10' }}>
                    <Form.Group>
                      <Form.Label>
                        Select Customers
                      </Form.Label>
                      <FormSelect 
                        value={values.selectedCustomer}
                        onChange={e =>
                          setFieldValue(
                            "selectedCustomer", e.target.value)
                        }
                        name='selectedCustomer'
                        onBlur={handleBlur}
                      >
                        <option value="">Select </option>
                        {formattedCustomers.map((s, i) => <option value={s.key} key={i}>{s.value}</option>)}
                      </FormSelect>
                      <Form.Text className="text-small text-danger">
                        {errors.selectedCustomer && touched.selectedCustomer && errors.selectedCustomer}
                      </Form.Text>
                      {isNotSetupCorrectly ?
                        errorMsgList.map((i, index) => <Feedback key={index}> {i} </Feedback>)
                        : null}
                    </Form.Group>
                  </Col>
                </Row>
                <Row className='bottom-spacer top-spacer'>
                  <Col md={{ offset: '2', span: '4' }}>
                    <Button variant='outline-dark' block onClick={() => modalRef.current?.handleClose()} disabled={isSubmitting}>
                      Cancel
                    </Button>
                  </Col>
                  <Col md={4}>
                    <Button type="submit" variant='success' block disabled={isSubmitting}>
                      {
                        isSubmitting ? 'Checking... ' : 'Check'
                      }
                    </Button>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </DismissableModal>
      </Card.Body>
    </Card>
  );
}

export default CheckCustomerConfigurationOnSendGrid;
